import { useAssetListStore, useRootStore } from "contexts/RootStore.context";
import { useState } from "react";
import { Asset } from "types/asset";
import { alertErrorMessage, alertSuccessMessage } from "utils/alerts";

export function useAssetFlyout(asset: Asset | null, onClose: () => void) {

  const { ArchiveAsset } = useAssetListStore()
  const { availableFeatures } = useRootStore()
  const [loading, setLoading] = useState(false)
  const [archiveModal, setArchiveModal] = useState(false)
  const [statusModal, setStatusModal] = useState(false)

  const handleArchiveAsset = () => {
    if (!asset)
      return;

    setLoading(true);
    ArchiveAsset(asset.asset_id)
      .then(() => {
        setLoading(false);
        onClose();
        setArchiveModal(false);
        alertSuccessMessage(
          `${asset.asset_name} - ${asset.asset_type.name} has been archived`,
        );
      })

      .catch((err) => {
        setLoading(false);
        console.log(err);
        alertErrorMessage(
          `An error occurred ${asset.asset_name} has not been archived`,
        );
      });
  };

  const updateAssetStatus = () => {
    if (!availableFeatures.asset_status) {
      alertErrorMessage("Asset Status can't be updated right now, try again in a few moments");
      return;
    }
    setStatusModal(true)
  }

  return {
    archiveModal,
    setArchiveModal,
    handleArchiveAsset,
    loading,
    updateAssetStatus,
    statusModal,
    setStatusModal,
  }
}